module.exports = __webpack_public_path__ + "static/media/ipk2020_landing_page_banner.6db15efc.jpeg";